import {Component, Input} from '@angular/core';
import {TranslateDirective} from "../../directives/translate.directive";

@Component({
    selector: 'app-pill',
    imports: [
        TranslateDirective
    ],
    templateUrl: './pill.component.html',
    styleUrl: './pill.component.scss'
})
export class PillComponent {
  @Input() public type: 'default' | 'small' = 'default';
  @Input() public fontSize: 'fs-small' | 'fs-default' | 'fs-normal' | 'fs-6' | '' = '';
  @Input() public fontColor: 'text-muted' | 'text-white' | 'text-primary' | 'text-secondary' | 'text-light' | 'text-danger' | 'text-success' | 'text-orange' | 'text-warning' | '' = '';
  @Input() public bgColor: 'bg-primary' | 'bg-lightpurple' | 'bg-secondary' | 'bg-transparent' | 'bg-faintgreen' | 'bg-pink' | 'bg-warning' | 'bg-danger' | 'bg-blue' | 'bg-grey' | 'bg-lightgrey' | 'bg-faintorange' | 'bg-success' = 'bg-primary';
  @Input() public border: boolean = false;
  @Input() public brdColor: 'brd-success' | 'brd-orange' | 'brd-secondary' | 'brd-primary' | 'brd-muted' | 'brd-warning' | '' = '';
  @Input() public rounded: boolean = true;
}
